// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  padding: 10px;
  background-color: var(--planeed-color-white);
}
@media only screen and (min-width: 460px) {
  .content {
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.05));
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
.content h3 {
  padding-bottom: 0;
  margin: 0;
  color: var(--ion-color-medium);
  font-size: 16px;
}

.post-content {
  background: var(--planeed-color-white);
  min-height: 300px;
  border: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
@media only screen and (min-width: 460px) {
  .post-content {
    background: transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

ion-segment-button {
  font-size: 11px;
  --background-checked: var(--ion-color-secondary);
  --color-checked: var(--planeed-color-white);
  --ion-background-color: var(--ion-color-secondary);
  --indicator-color: transparent !important;
  background: var(--planeed-color-white);
}

.segment-button-checked {
  background: var(--ion-color-secondary);
  border-radius: 9px !important;
}

.swiper .swiper-slide {
  height: 600px !important;
  overflow: auto;
}

.impact_score_txt {
  color: var(--ion-color-warning);
}

.content-not-found {
  color: var(--ion-color-medium);
  font-size: 14px;
  padding: 20px;
  text-align: center;
}

.main-content {
  color: var(--ion-color-secondary);
}
@media only screen and (min-width: 460px) {
  .main-content {
    background: var(--planeed-color-white);
  }
}
.main-content span {
  font-size: 12px;
}

.alignment-center {
  display: flex;
  align-items: center;
}

.h2-center {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  row-gap: 15px;
  text-align: center;
  color: var(--ion-color-secondary);
  margin-top: 25px;
  margin-bottom: 25px;
}
@media only screen and (min-width: 460px) {
  .h2-center {
    background-color: white;
    padding-top: 25px;
    padding-bottom: 25px;
    margin-top: 0;
  }
}
.h2-center ion-icon {
  margin-right: 12px;
}

p {
  margin: 0 0;
}

.content-not-found {
  color: var(--ion-color-medium);
  font-size: 14px;
  padding: 20px;
  text-align: center;
}

.globle-icon {
  width: 13px;
  position: absolute;
  left: -6px;
  margin-top: 4px;
}

ion-segment-button {
  min-width: auto !important;
}

.help-icon {
  background: var(--ion-color-tertiary-tint);
  color: var(--planeed-color-white);
  width: 15px;
  height: 15px;
  border-radius: 13px;
  font-size: 11px;
  margin-left: 12px;
  cursor: pointer;
}

.modal-wrapper, .modal-shadow {
  background: transparent;
}

.p-users {
  padding-left: 20px;
  text-align: left;
  color: var(--ion-color-medium);
  margin: 0;
}

.centeredText {
  display: flex;
  justify-content: center;
}

.textNotFound {
  padding-top: 15px;
  min-height: 60px;
  color: #888;
  text-align: center;
  max-width: 80vw;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
